import type { ReactNode } from "react";

interface DropdownOptionProps {
  label: string;
  count?: number;
  icon?: ReactNode;
  isSelected?: boolean;
  isDisabled?: boolean;
  onSelect: () => void;
}

/** A single row in any of the filter-bar dropdowns. */
export default function DropdownOption({
  label,
  count,
  icon,
  isSelected = false,
  isDisabled = false,
  onSelect,
}: DropdownOptionProps) {
  return (
    <button
      type="button"
      onClick={onSelect}
      disabled={isDisabled}
      aria-pressed={isSelected}
      className={`flex items-center justify-between w-full px-2.5 gap-3 font-roboto text-base text-left leading-8 text-secondary rounded transition-colors ${
        isSelected ? "bg-[#E7E7E9]" : ""
      } ${isDisabled ? "opacity-38 cursor-not-allowed" : "hover:bg-[#E7E7E9]"}`}>
      <span className="flex items-center min-w-0 gap-2">
        {icon}
        <span className="truncate">{label}</span>
      </span>
      {typeof count === "number" && <span className="shrink-0 text-xs text-gray-5">{count}</span>}
    </button>
  );
}
